import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { wordCount } from './page-tab';

/**
 * A suburb page's own content in its Page tab (#262): the fields the template's blocks read. Opening paragraph (the
 * hero's lead), About, the hero photo and the FAQs. An empty one hides its block, and says so. Presentational: the
 * host owns the form and the upload.
 */
@Component({
  selector: 'app-suburb-page-content',
  templateUrl: './suburb-page-content.component.html',
  styleUrls: ['./suburb-page.scss'],
})
export class SuburbPageContentComponent {
  @Input() form!: FormGroup;
  /** AI drafts of the opening paragraph waiting for a person (suburbs only). */
  @Input() draftsWaiting = 0;
  @Input() faqOptions: Array<{ label: string; value: string }> = [];
  @Input() heroPreview: string | null = null;
  @Output() openDrafts = new EventEmitter<void>();
  @Output() uploadHero = new EventEmitter<void>();
  @Output() removeHero = new EventEmitter<void>();

  get introWords(): number {
    return wordCount(this.form.get('intro')?.value);
  }

  empty(name: string): boolean {
    const v = this.form.get(name)?.value;
    return Array.isArray(v)
      ? v.length === 0
      : v === null || v === undefined || String(v).trim() === '';
  }
}
